@use '~/theme/theme' as *;
@use '~/theme/typography' as typography;

.valueContainer {
  font-family: 'Public Sans', sans-serif;

  @include typography.body2;
  @include typography.regular;

  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--background-color);
  color: var(--color);
  display: flex;
  align-items: center;
  height: 38px;
  width: 100%;
  cursor: var(--cursor);
  gap: spacing(1);
  padding: spacing(1) var(--value-horizontal-padding);

  &[data-hovered='true'] {
    --border-color: #{color(violet-600)};
  }
}

.container {
  --border-color: #{color(grey-600)};
  --background-color: white;
  --color: #{color(grey-800)};
  --cursor: pointer;
  --action-icon-size: 24px;
  --value-horizontal-padding: #{spacing(1.5)};

  &[data-open='true'] .valueContainer {
    --border-color: #{color(violet-600)};

    outline: 1px solid var(--border-color);
  }

  .valueContainer[data-focus-visible] {
    --border-color: #{color(violet-600)};

    outline: 1px solid var(--border-color);
  }

  & .valueContainer[data-disabled] {
    --background-color: #{color(grey-100)};
    --border-color: #{color(grey-400)};
    --color: #{color(grey-500)};
    --cursor: default;
  }
}

.triggerContainer {
  position: relative;
}

.value {
  flex-grow: 1;
  text-align-last: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &[data-placeholder='true'] {
    color: color(grey-600);
  }
}

.icon {
  height: var(--action-icon-size);
  width: var(--action-icon-size);
  padding: 2px;
}

.clear {
  position: absolute;
  right: calc(var(--value-horizontal-padding) + 2px + var(--action-icon-size));
  top: 50%;
  transform: translateY(-50%);
}

.clearPlaceholder {
  visibility: hidden;
  margin-right: 2px;
  width: var(--action-icon-size);
}
